import React, { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { toast } from "react-toastify";

const Settings = () => {
  const [adsEnabled, setAdsEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const docSnap = await getDoc(doc(db, "appConfig", "ads"));
      if (docSnap.exists()) {
        setAdsEnabled(docSnap.data().adsEnabled !== false);
      }
    } catch (err) {
      console.error("Error loading settings:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async () => {
    const newValue = !adsEnabled;
    setSaving(true);
    try {
      await setDoc(
        doc(db, "appConfig", "ads"),
        { adsEnabled: newValue, updatedAt: new Date() },
        { merge: true }
      );
      setAdsEnabled(newValue);
      toast.success(`Ads ${newValue ? "enabled" : "disabled"} globally`);
    } catch (err) {
      toast.error("Failed to save settings");
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading settings...</div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-2xl">
      <h1 className="text-2xl font-bold mb-6">Settings</h1>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold">Advertisements</h2>
            <p className="text-gray-500 text-sm mt-1">
              Globally enable or disable interstitial ads in the Books section.
              When disabled, no ads will be shown to any user.
            </p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={adsEnabled}
              onChange={handleToggle}
              disabled={saving}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600"></div>
            <span className="ml-3 text-sm font-medium text-gray-700">
              {adsEnabled ? "Enabled" : "Disabled"}
            </span>
          </label>
        </div>

        {saving && (
          <div className="mt-4 text-sm text-blue-600 flex items-center">
            <svg className="animate-spin h-4 w-4 mr-2" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
            Saving...
          </div>
        )}
      </div>
    </div>
  );
};

export default Settings;
